import { PhoneAuthPage } from '@/components/auth/PhoneAuthPage';

const Login = () => <PhoneAuthPage variant="login" />;

export default Login;
